import React from 'react';import './ProductFormByType.css';
/**
 * Messtechnik-spezifisches Formular
 * Blanko-Formular für Mess- und Kontrollgeräte
 */
function MeasurementForm({ formData, handleChange, disabled }) {
  return (
    <div className="product-type-form-section">
      <h3>📊 Messtechnik-Spezifikationen</h3>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="measurementType">📏 Messtyp</label>
          <select
            id="measurementType"
            name="measurementType"
            value={formData.measurementType || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Bitte wählen --</option>
            <option value="Temperatur">Temperatur</option>
            <option value="Luftfeuchtigkeit">Luftfeuchtigkeit</option>
            <option value="pH-Wert">pH-Wert</option>
            <option value="EC/TDS">EC/TDS (Leitfähigkeit)</option>
            <option value="Licht">Licht/PAR</option>
            <option value="Co2">Co2-Konzentration</option>
            <option value="Multi">Multi-Parameter</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="measurementRange">📐 Messbereich</label>
          <input
            type="text"
            id="measurementRange"
            name="measurementRange"
            value={formData.measurementRange || ''}
            onChange={handleChange}
            placeholder="z.B. 0-100% RH oder 0-14 pH"
            disabled={disabled}
          />
        </div>

        <div className="form-group">
          <label htmlFor="accuracy">✅ Genauigkeit</label>
          <input
            type="text"
            id="accuracy"
            name="accuracy"
            value={formData.accuracy || ''}
            onChange={handleChange}
            placeholder="z.B. ±2% oder ±0.1 pH"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="connectivity">🔗 Konnektivität</label>
          <select
            id="connectivity"
            name="connectivity"
            value={formData.connectivity || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="Analog">Analog</option>
            <option value="Digital">Digital</option>
            <option value="Bluetooth">Bluetooth</option>
            <option value="WiFi">WiFi</option>
            <option value="Kabelgebunden">Kabelgebunden</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="displayType">🖥️ Display</label>
          <select
            id="displayType"
            name="displayType"
            value={formData.displayType || ''}
            onChange={handleChange}
            disabled={disabled}
          >
            <option value="">-- Keine Angabe --</option>
            <option value="LCD">LCD</option>
            <option value="LED">LED</option>
            <option value="Digital">Digital</option>
            <option value="App-basiert">App-basiert</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="batteryType">🔋 Stromversorgung</label>
          <input
            type="text"
            id="batteryType"
            name="batteryType"
            value={formData.batteryType || ''}
            onChange={handleChange}
            placeholder="z.B. USB, Batterie, 230V"
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="measurementFeatures">Spezielle Features (optional)</label>
        <textarea
          id="measurementFeatures"
          name="measurementFeatures"
          value={formData.measurementFeatures || ''}
          onChange={handleChange}
          placeholder="z.B. Datenspeicherung, Alarme, Kalibrierung, etc."
          rows="3"
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default MeasurementForm;
